/**
 * Desloguea a un usuario del sistema
 * Borra los datos de loggedUser del storage
 * @example
 * ```js
 *   logout()
 * ```
 */
const logout = payload => {
  return {
    type: 'LOGOUT',
    payload
  }
}

export default logout
